
import { Component, Prop, Vue,Watch} from 'vue-property-decorator';
//import { NoticeProps } from "@/scripts/datatypes";
//import { is } from 'vee-validate/dist/rules';

@Component
export default class Notice extends Vue {
	css = {}
	timers = [] as Array<number>

	@Prop({type: Boolean,default: false}) private isShow!: boolean;
	@Prop({type: Boolean,default: false}) private deleteButton!: boolean;
	@Prop({type: String,default: ''}) private message!: string;
	@Prop({type: Object,default: () => ({})}) private type!: object;
	@Prop({type: Number,default: 5000}) private duration!: number;

	async timer(second: number){
		await new Promise((resolve) => {
			this.timers.push(window.setTimeout(() => {
						resolve(null)
				}, second)
		)})
	}

	@Watch('isShow')
	async changeIsShow(isShow: boolean){
		if(isShow && this.duration > 0 && ! this.deleteButton){
      let timer: number | undefined
      const transitionDuration = (this.duration * 0.1 > 500 ) ? 500 : Math.floor(this.duration * 0.1)
			while((timer =	this.timers.shift())){
				clearTimeout(timer)
			}
			this.css = {}

			await this.timer(this.duration - transitionDuration)
			
			this.css = {
				height: 0,
				padding: 0,
				border: 0,
				margin: 0,
				transition: `all ${transitionDuration}ms ease-out`
			}
			
			await this.timer(transitionDuration)
			this.$emit('delete')
			this.css = {}
		}
	}
}
